// components/IconButton.tsx
import React from 'react'

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon: React.ReactNode
    size?: 'sm' | 'md'
}

const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
}

const IconButton: React.FC<IconButtonProps> = ({ icon, size = 'sm', className = '', ...props }) => {
    return (
        <button
            type="button"
            className={`
        flex items-center justify-center
        rounded-full
        hover:bg-gray-100
        transition-all duration-200
        ${sizeClasses[size]}
        ${className}
      `}
            {...props}
        >
            {icon}
        </button>
    )
}

export default IconButton
